// router/modules/system.ts

import type { RouteRecordRaw } from 'vue-router';

export const systemRoutes: RouteRecordRaw = {
    path: 'system',
    components: {
        default: () => import('@/layouts/modules/sys-data/SysDataLayout.vue'),
        sidebar: () => import('@/layouts/modules/sys-data/SysDataAside.vue')
    },
    children: [
        {
            path: 'app-version',
            name: 'appVersion',
            component: () => import('@/views/modules/sys-data/AppVersionView.vue'),
        },
        {
            path: 'gender-types',
            name: 'schoolGender',
            component: () => import('@/views/modules/sys-data/school/GenderTypesView.vue'),
            children: [
                {
                    path: 'create',
                    name: 'createGenderTypes',
                    component: () => import('@/components/modules/sys-data/school/gender-types/GenderTypesCreateModal.vue'),
                },
                {
                    path: ':schoolGenderId/update',
                    name: 'updateSchoolGender',
                    component: () => import('@/components/modules/sys-data/school/gender-types/GenderTypesEditModal.vue'),
                }
            ],
        },
        {
            path: 'boarding-status',
            name: 'boardingStatus',
            component: () => import('@/views/modules/sys-data/school/BoardingStatusView.vue'),
            children: [
                {
                    path: 'create',
                    name: 'createBoardingStatus',
                    component: () => import('@/components/modules/sys-data/school/boarding-status/BoardingStatusCreateModal.vue'),
                },
                {
                    path: ':boardingStatusId/update',
                    name: 'updateBoardingStatus',
                    component: () => import('@/components/modules/sys-data/school/boarding-status/BoardingStatusEditModal.vue'),
                }
            ],
        },
        {
            path: 'school-gender-status',
            name: 'schoolGenderStatus',
            component: () => import('@/views/modules/sys-data/school/SchoolGenderStatusView.vue'),
            children: [
                {
                    path: 'create',
                    name: 'createSchoolGenderStatus',
                    component: () => import('@/components/modules/sys-data/school/school-gender-status/SchoolGenderStatusCreateModal.vue'),
                },
                {
                    path: ':schoolGenderStatusId/update',
                    name: 'updateSchoolGenderStatus',
                    component: () => import('@/components/modules/sys-data/school/school-gender-status/SchoolGenderStatusEditModal.vue'),
                }
            ],
        },
        {
            path: 'school-types',
            name: 'schoolTypes',
            component: () => import('@/views/modules/sys-data/school/SchoolTypesView.vue'),
            children: [
                {
                    path: 'create',
                    name: 'createSchoolTypes',
                    component: () => import('@/components/modules/sys-data/school/school-types/SchoolTypesCreateModal.vue'),
                },
                {
                    path: ':schoolTypesId/update',
                    name: 'updateSchoolTypes',
                    component: () => import('@/components/modules/sys-data/school/school-types/SchoolTypeEditModal.vue'),
                }
            ],
        },
        {
            path: 'relationships',
            name: 'relationships',
            component: () => import('@/views/modules/sys-data/school/RelationshipView.vue'),
            children: [
                {
                    path: 'create',
                    name: 'createRelationships',
                    component: () => import('@/components/modules/sys-data/school/relationships/RelationshipCreateModal.vue'),
                },
                {
                    path: ':relationshipId/update',
                    name: 'updateRelationship',
                    component: () => import('@/components/modules/sys-data/school/relationships/RelationshipEditModal.vue'),
                }
            ],
        },
        {
            path: 'degree-level',
            name: 'degreeLevel',
            component: () => import('@/views/modules/sys-data/school/DegreeLevelView.vue'),
            children: [
                {
                    path: 'create',
                    name: 'createDegreeLevels',
                    component: () => import('@/components/modules/sys-data/school/degree-levels/DegreeLevelCreateModal.vue'),
                },
                {
                    path: ':degreeLevelId/update',
                    name: 'updateDegreeLevel',
                    component: () => import('@/components/modules/sys-data/school/degree-levels/DegreeLevelEditModal.vue'),
                }
            ],
        },
        {
            path: 'degree-institutions',
            name: 'degreeInstitutions',
            component: () => import('@/views/modules/sys-data/school/DegreeInstitutionsView.vue'),
            children: [
                {
                    path: 'create',
                    name: 'createDegreeInstitutions',
                    component: () => import('@/components/modules/sys-data/school/degree-institution/DegreeInstitutionsCreateModal.vue'),
                },
                {
                    path: ':degreeInstitutionId/update',
                    name: 'updateDegreeInstitution',
                    component: () => import('@/components/modules/sys-data/school/degree-institution/DegreeInstitutionEditModal.vue'),
                }
            ],
        },
        {
            path: 'degree-level',
            name: 'degreeLevel',
            component: () => import('@/views/modules/sys-data/school/DegreeLevelView.vue'),
            children: [
                {
                    path: 'create',
                    name: 'createDegreeLevels',
                    component: () => import('@/components/modules/sys-data/school/degree-levels/DegreeLevelCreateModal.vue'),
                },
                {
                    path: ':degreeLevelId/update',
                    name: 'updateDegreeLevel',
                    component: () => import('@/components/modules/sys-data/school/degree-levels/DegreeLevelEditModal.vue'),
                }
            ],
        },
        {
            path: 'degree-field',
            name: 'degreeField',
            component: () => import('@/views/modules/sys-data/school/DegreeFieldsView.vue'),
            children: [
                {
                    path: 'create',
                    name: 'createDegreeField',
                    component: () => import('@/components/modules/sys-data/school/degree-field/DegreeFieldCreateModal.vue'),
                },
                {
                    path: ':degreeFieldId/update',
                    name: 'updateDegreeField',
                    component: () => import('@/components/modules/sys-data/school/degree-field/DegreeFieldEditModal.vue'),
                }
            ],
        },
        {
            path: 'staff-status',
            name: 'staffStatues',
            component: () => import('@/views/modules/sys-data/profile/StaffStatusView.vue'),
            children: [
                {
                    path: 'create',
                    name: 'createStaffStatuses',
                    component: () => import('@/components/modules/sys-data/profile/staff-status/StaffStatusCreateModal.vue'),
                },
                {
                    path: ':staffStatusId/update',
                    name: 'updateStaffStatues',
                    component: () => import('@/components/modules/sys-data/profile/staff-status/StaffStatusEditModal.vue'),
                }
            ],
        },
        {
            path: 'student-status',
            name: 'studentStatues',
            component: () => import('@/views/modules/sys-data/profile/StudentStatusView.vue'),
            children: [
                {
                    path: 'create',
                    name: 'createStudentStatuses',
                    component: () => import('@/components/modules/sys-data/profile/student-status/StudentStatusCreateModal.vue'),
                },
                {
                    path: ':studentStatusId/update',
                    name: 'updateStudentStatues',
                    component: () => import('@/components/modules/sys-data/profile/student-status/StudentStatusEditModal.vue'),
                }
            ],
        }
    ]
};